<ng-template #content>
    <ng-content></ng-content>
</ng-template>
<ng-template #menu>
    <ng-content select="[menu]"></ng-content>
</ng-template>
